export const PRODUCT_NAME = "SpecAgent" 
export const API_SUCCESS_RESPONSE_CODE= 200
export const API_SUCCESS_RESPONSE_CREATED_CODE= 201
export const API_AUTHORIZATION_CODE= 401
export const APP_CLIENT = process.env.REACT_APP_CLIENT

export const CONTRACT_STATUS_CHECK_POLLING_DURATION = 30000   //Seconds
export const AUTH_TOKEN_REFRESH_DURATION = 900000  //Seconds
export const CONTRACT_POLLING_MAX_COUNT = 50 

export const OVERVIEW_META_DATA  = {
   "FilePath":{
     "label":"TITLE",
     "value":""   
    },
    "BioworldDocumentNo":{
        "label":"DOCUMENT NO",
        "value":""   
    },
    "ContractID":{
        "label":"DOCUMENT NO",
        "value":""   
    },
    "documenttype":{
        "label":"DOCUMENT TYPE",
        "value":""   
    },  
    "licensor":{
        "label":"PARTY1",
        "value":""   
    }, 
    "version":{
        "label":"Version",
        "value":""   
    },
    "effectivedate":{
        "label":"EFFECTIVE DATE",
        "value":""   
    },
    "expirationdate":{
        "label":"EXPIRY DATE",
        "value":""   
    },
    "sell-off period":{
        "label":"SELLOFF PERIOD",
        "value":"",
        "units":"days"    
    },
    "LicensorLegalName":{
        "label":"Licensor Name",
        "value":""   
    },
    "startdate":{
        "label":"Effective Date",
        "value":""   
    },
    "expirationdate":{
        "label":"Expiry Date",
        "value":""   
    },
    "PayableContact":{
        "label":"Payable To",
        "value":""   
    },
    
    
}